import type { BrandMentionPlatform } from '@/types/brandMentions'

export type PreviewMention = {
	platform: BrandMentionPlatform
	author: string
	text: string
	title?: string
	kind?: 'Comment'
	time: string
}

export function previewMentions(isFrench: boolean): PreviewMention[] {
	if (isFrench) {
		return [
			{
				platform: 'x',
				author: 'Alex Martin',
				text: 'On a testé cet outil de feedback, le widget est vraiment fluide et les retours arrivent au bon endroit.',
				time: '2h',
			},
			{
				platform: 'reddit',
				author: 'u/saasfounders',
				title: 'Quelle stack pour collecter le feedback in-app ?',
				text: 'On cherche quelque chose de simple à installer. Le widget est propre et les mentions de marque aident à suivre les discussions.',
				kind: 'Comment',
				time: '5h',
			},
			{
				platform: 'linkedin',
				author: 'Camille Durand',
				text: 'On entend de plus en plus parler de cette solution. L’onboarding est clair et l’équipe produit répond vite.',
				time: '1j',
			},
			{
				platform: 'facebook',
				author: 'Growth Lab',
				text: 'Quelqu’un a déjà utilisé leur widget de recueil d’avis ? Les premiers retours ont l’air très positifs.',
				time: '2j',
			},
			{
				platform: 'youtube',
				author: 'Indie Build',
				title: 'Comment on suit ce que les gens disent du produit',
				text: 'La veille des mentions centralise X, Reddit et le reste. Pratique pour répondre sans tout surveiller à la main.',
				kind: 'Comment',
				time: '3j',
			},
		]
	}

	return [
		{
			platform: 'x',
			author: 'Alex Martin',
			text: 'Tried this feedback tool today. The widget feels smooth and the responses actually land in one place.',
			time: '2h',
		},
		{
			platform: 'reddit',
			author: 'u/saasfounders',
			title: 'What are you using for in-app feedback?',
			text: 'Looking for something easy to install. The widget looks clean and brand mentions help catch conversations we were missing.',
			kind: 'Comment',
			time: '5h',
		},
		{
			platform: 'linkedin',
			author: 'Camille Durand',
			text: 'Hearing more teams talk about this. Onboarding is clear and the product team replies fast.',
			time: '1d',
		},
		{
			platform: 'facebook',
			author: 'Growth Lab',
			text: 'Has anyone used their review widget yet? Early comments look really positive.',
			time: '2d',
		},
		{
			platform: 'youtube',
			author: 'Indie Build',
			title: 'How we keep up with what people say about the product',
			text: 'Brand mentions pulls X, Reddit and the rest into one inbox. Much easier than checking every network by hand.',
			kind: 'Comment',
			time: '3d',
		},
	]
}
